module.exports = __webpack_public_path__ + "static/media/22.93f37bc1.jpg";